import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function ContactMailAddress(props) {
    return (
        <FormikInput
            name={'contactMailAddress'}
            label={'shippingMethods.form.field.contactMailAddress.label'}
            placeholder={'shippingMethods.form.field.contactMailAddress.placeholder'}
            required={true}
        />
    );
}

export default ContactMailAddress;
